<template>
  <div>
    <div class="btn btn-neutral btn-icon" @click="modal = true">
      <span class="nav-link-inner--text">Subscribe</span>
      <span class="btn-inner--icon">
        <i class="fas fa-arrow-circle-right ml-2"></i>
      </span>
    </div>

    <modal ref="modal" :show.sync="modal" title="Subscribe" id="modal">
      <h6 slot="header" class="modal-title">Subscribe to status updates</h6>
      <monitor-notify
        v-bind:website-info="website"
        v-on:close-modal="modal = false"
      ></monitor-notify>

      <template v-slot:footer>
        <div></div>
      </template>

      <!--
      <template v-slot:footer>
        <base-button @click="modal = false" type="secondary">
          Close
        </base-button>
      </template>
      -->
    </modal>
  </div>
</template>
<script>
import MonitorNotify from "@/components/MonitorNotify";

import { mapState, mapGetters, mapActions } from "vuex";

//const { mapState, mapGetters, mapActions } = createNamespacedHelpers("website");

export default {
  name: "SubscribeButton",
  components: {
    MonitorNotify
  },
  data() {
    return {
      modal: false
    };
  },
  computed: {
    ...mapState("website", {
      website: (state) => state.data
    })
  },

  watch: {},

  async created() {}
};
</script>
<style>
/*@incude media-breakpoint-down(lg) { */

.alert-text-header {
  font-size: 20px;
  font-weight: 600;
}

.alert-text-sub {
  padding-top: 3px;
  font-size: 14px;
}

.dashboard-container {
  margin-top: 45px;
}

.route-monitor .dashboard-container {
  margin-top: 95px;
}

.monitor-background {
  background-color: #f6f9fc;
}
.profile-header {
  /*background-image: url(/img/theme/profile-cover.jpg);*/
  background-size: cover;
  background-position: center top;
  min-height: 400px;
}
.monitor-card {
  background: #5e72e4 !important;
}

.monitor-card.card-success {
  background: #2bce89 !important;
}
</style>
